import { setCookie, getCookie } from './cookiesUtils';
import { getVarConfig } from './environment';

const buildExpiresDate = (expiresInSeconds = 0) => {
  const ONE_DAY_MS = 86400000;
  const now = new Date();
  return new Date(now.getTime() + expiresInSeconds * 1000 + ONE_DAY_MS);
};

export default async function fetchAuth() {
  const accessToken = localStorage.getItem('bearer');
  if (accessToken) return { access_token: accessToken };

  const urlService = getVarConfig({ key: 'REACT_APP_SERVICES_URL' }) + 'oauth/token';

  const customerId = localStorage.getItem('customerId');

  return fetch(urlService, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ customerId }),
  })
    .then((res) => {
      if (res.ok) return res.json();
      throw new Error('Token request failed');
    })
    .then((data) => {
      const { access_token, expires_in } = data;
      const expires = buildExpiresDate(expires_in);
      setCookie('bearer', access_token, { expires });
      return data;
    })
    .catch((error) => {
      console.error('Auth error:', error);
      return {};
    });
}
